import {CopilotIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {forwardRef} from 'react'

export interface CopilotAssignmentButtonProps {
  onClick: () => void
}

export const CopilotAssignmentButton = forwardRef<HTMLButtonElement, CopilotAssignmentButtonProps>(({onClick}, ref) => (
  <Button ref={ref} leadingVisual={CopilotIcon} size="small" block onClick={onClick}>
    Assign to Copilot
  </Button>
))

CopilotAssignmentButton.displayName = 'CopilotAssignmentButton'
